// PWA install prompt + offline mode strings
const pwa = {
  pt: {
    installCardTitle: 'Instalar no telemóvel',
    installBullet1: 'Abre num toque',
    installBullet2: 'Treinos sem internet',
    installBullet3: 'Não ocupa espaço',
    installHowTo: 'Como instalar',
    installTitle: 'Instala a app no telemóvel',
    installSubtitle: 'Acesso rápido, ecrã inteiro e treinos disponíveis sem internet.',
    installAction: 'Instalar app',
    installDismiss: 'Dispensar',
    installIosStep1: 'Toca em Partilhar',
    installIosStep2: 'Escolhe "Adicionar ao ecrã principal"',
    offlineMode: 'Sem ligação',
    offlinePending: '{count} por sincronizar',
    offlineSyncing: 'A sincronizar {count} registo(s)...',
    offlineSynced: '{count} registo(s) de treino sincronizado(s)',
    offlineSavedLocally: 'Sem internet. Guardámos o registo e enviamos quando voltares a ter ligação.',
    offlinePendingBadge: 'Por sincronizar'
  },
  en: {
    installCardTitle: 'Install on your phone',
    installBullet1: 'Opens in one tap',
    installBullet2: 'Workouts without internet',
    installBullet3: 'Takes no storage',
    installHowTo: 'How to install',
    installTitle: 'Install the app on your phone',
    installSubtitle: 'Quick access, full screen and workouts available without internet.',
    installAction: 'Install app',
    installDismiss: 'Dismiss',
    installIosStep1: 'Tap Share',
    installIosStep2: 'Choose "Add to Home Screen"',
    offlineMode: 'Offline',
    offlinePending: '{count} to sync',
    offlineSyncing: 'Syncing {count} entry(ies)...',
    offlineSynced: '{count} workout entry(ies) synced',
    offlineSavedLocally: 'No internet. We saved your entry and will send it once you are back online.',
    offlinePendingBadge: 'Pending sync'
  },
  es: {
    installCardTitle: 'Instalar en el móvil',
    installBullet1: 'Se abre con un toque',
    installBullet2: 'Entrenos sin internet',
    installBullet3: 'No ocupa espacio',
    installHowTo: 'Cómo instalar',
    installTitle: 'Instala la app en el móvil',
    installSubtitle: 'Acceso rápido, pantalla completa y entrenos disponibles sin internet.',
    installAction: 'Instalar app',
    installDismiss: 'Descartar',
    installIosStep1: 'Toca Compartir',
    installIosStep2: 'Elige "Añadir a pantalla de inicio"',
    offlineMode: 'Sin conexión',
    offlinePending: '{count} por sincronizar',
    offlineSyncing: 'Sincronizando {count} registro(s)...',
    offlineSynced: '{count} registro(s) de entreno sincronizado(s)',
    offlineSavedLocally: 'Sin internet. Guardamos tu registro y lo enviaremos cuando vuelvas a tener conexión.',
    offlinePendingBadge: 'Por sincronizar'
  },
  fr: {
    installCardTitle: 'Installer sur le téléphone',
    installBullet1: "S'ouvre en un geste",
    installBullet2: 'Séances sans internet',
    installBullet3: 'Ne prend pas de place',
    installHowTo: 'Comment installer',
    installTitle: "Installe l'app sur ton téléphone",
    installSubtitle: 'Accès rapide, plein écran et séances disponibles sans internet.',
    installAction: "Installer l'app",
    installDismiss: 'Ignorer',
    installIosStep1: 'Appuie sur Partager',
    installIosStep2: 'Choisis "Sur l\'écran d\'accueil"',
    offlineMode: 'Hors ligne',
    offlinePending: '{count} à synchroniser',
    offlineSyncing: 'Synchronisation de {count} entrée(s)...',
    offlineSynced: '{count} entrée(s) synchronisée(s)',
    offlineSavedLocally: "Pas d'internet. Ton entrée est enregistrée et sera envoyée dès le retour du réseau.",
    offlinePendingBadge: 'À synchroniser'
  },
  de: {
    installCardTitle: 'Auf dem Handy installieren',
    installBullet1: 'Öffnet mit einem Tipp',
    installBullet2: 'Workouts ohne Internet',
    installBullet3: 'Braucht keinen Speicher',
    installHowTo: 'So installierst du',
    installTitle: 'Installiere die App auf dem Handy',
    installSubtitle: 'Schneller Zugriff, Vollbild und Workouts auch ohne Internet.',
    installAction: 'App installieren',
    installDismiss: 'Schließen',
    installIosStep1: 'Tippe auf Teilen',
    installIosStep2: 'Wähle "Zum Home-Bildschirm"',
    offlineMode: 'Offline',
    offlinePending: '{count} zu synchronisieren',
    offlineSyncing: 'Synchronisiere {count} Eintrag/Einträge...',
    offlineSynced: '{count} Trainingseintrag/-einträge synchronisiert',
    offlineSavedLocally: 'Kein Internet. Dein Eintrag wurde gespeichert und wird gesendet, sobald du wieder online bist.',
    offlinePendingBadge: 'Ausstehend'
  },
  it: {
    installCardTitle: 'Installa sul telefono',
    installBullet1: 'Si apre con un tocco',
    installBullet2: 'Allenamenti senza internet',
    installBullet3: 'Non occupa spazio',
    installHowTo: 'Come installare',
    installTitle: 'Installa l\'app sul telefono',
    installSubtitle: 'Accesso rapido, schermo intero e allenamenti disponibili senza internet.',
    installAction: 'Installa app',
    installDismiss: 'Chiudi',
    installIosStep1: 'Tocca Condividi',
    installIosStep2: 'Scegli "Aggiungi a Home"',
    offlineMode: 'Offline',
    offlinePending: '{count} da sincronizzare',
    offlineSyncing: 'Sincronizzazione di {count} voce/voci...',
    offlineSynced: '{count} voce/voci di allenamento sincronizzate',
    offlineSavedLocally: 'Nessuna connessione. Abbiamo salvato la voce e la invieremo appena torni online.',
    offlinePendingBadge: 'Da sincronizzare'
  }
};

export default pwa;
